import { render, staticRenderFns } from "./RightNews.vue?vue&type=template&id=b6de31ac&scoped=true&"
import script from "./RightNews.vue?vue&type=script&lang=js&"
export * from "./RightNews.vue?vue&type=script&lang=js&"
import style0 from "./RightNews.vue?vue&type=style&index=0&id=b6de31ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de31ac",
  null
  
)

export default component.exports